import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import devisNewProductBo from '../../../data/devis/DevisNewProduct';
import toKeyValueJsonArray from '../../../../services/ToKeyValueJsonArray';
import UnitesService from '../../../../services/unites/UniteService';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import DecimalField from '../../../custom/DecimalField';
import IconButton from '@material-ui/core/IconButton';
import AddCircle from '@material-ui/icons/AddCircle';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

import './DevisContentTab.css';

const styles = theme => ({
    table: {
        minWidth: 700,
    }
});

const unites = (toKeyValueJsonArray((new UnitesService()).getAll(), "uvId", "uvLibelle"));

class DevisContentTab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            customLines: 0
        };
    }

    handleChangeCustom = (id, parentId, categorieId) => event => {
        this.props.datas.productsAdded[parentId].contenu[(id * -1) - 1][event.target.name] = event.target.value;
        this.valueChange(id, parentId, categorieId, event);
    }

    valueChange(id, parentId, categorieId, event) {
        if (this.props.datas.content[categorieId] == null) {
            this.props.datas.content[categorieId] = {};
            this.setState({
                categorieId: {}
            });
        }
        if (this.props.datas.content[categorieId][parentId] == null) {
            this.props.datas.content[categorieId][parentId] = {};
            this.setState({
                categorieId: {
                    parentId: {}
                }
            });
        }
        if (this.props.datas.content[categorieId][parentId][id] == null) {
            this.props.datas.content[categorieId][parentId][id] = {};
            this.setState({
                categorieId: {
                    parentId: {
                        id: {}
                    }
                }
            });
        }
        this.props.datas.content[categorieId][parentId][id][event.target.name] = event.target.value;
        this.setState({
            categorieId: {
                parentId: {
                    id: { [event.target.name]: event.target.value }
                }
            }
        });
    }

    handleChange = (id, parentId, categorieId) => event => {
        this.valueChange(id, parentId, categorieId, event);
    }

    getValue(row, produitId, parentId, categorieId, target) {
        var retour = "";
        if (this.props.datas.content[categorieId] == null ||
            this.props.datas.content[categorieId][parentId] == null ||
            this.props.datas.content[categorieId][parentId][produitId] == null ||
            this.props.datas.content[categorieId][parentId][produitId][target] == null) {
            if (row[target] != null) {
                retour = row[target];
            }
        } else {
            retour = this.props.datas.content[categorieId][parentId][produitId][target];
        }
        if (retour == null) {
            retour = "";
        }
        return retour;
    }

    showFixRow(row, categorieProduitId, categorieId) {
        return (
            <TableRow key={row.produitId} className="devisContentCategories">
                <TableCell className="devisContentCategoriesLibelle">{row.produitLibelle}</TableCell>
                <TableCell className="devisContentCategoriesQuantite">
                    <DecimalField
                        id="quantite"
                        label="Quantité"
                        value={this.getValue(row, row.produitId, categorieProduitId, categorieId, "quantite")}
                        onChange={this.handleChange(row.produitId, categorieProduitId, categorieId)} />
                </TableCell>
                <TableCell className="devisContentCategoriesUnite">{unites[row.uniteId]}</TableCell>
                <TableCell className="devisContentCategoriesPrix">
                    <DecimalField
                        id="prix"
                        label="Prix"
                        value={this.getValue(row, row.produitId, categorieProduitId, categorieId, "prix")}
                        onChange={this.handleChange(row.produitId, categorieProduitId, categorieId)} />
                </TableCell>
            </TableRow>
        );
    }

    showCustomRow(row, categorieProduitId, categorieId) {
        var uniteList = [];
        for (var key in unites) {
            uniteList.push(<MenuItem key={key} value={key}>{unites[key]}</MenuItem>);
        }
        return (
            <TableRow key={row.produitId} className="devisContentCategories">
                <TableCell className="devisContentCategoriesLibelle">
                    <TextField
                        name="produitLibelle"
                        label="Libellé"
                        value={this.getValue(row, row.produitId, categorieProduitId, categorieId, "produitLibelle")}
                        onChange={this.handleChangeCustom(row.produitId, categorieProduitId, categorieId)}
                        margin="normal"
                    />
                </TableCell>
                <TableCell className="devisContentCategoriesQuantite">
                    <DecimalField
                        id="quantite"
                        label="Quantité"
                        value={this.getValue(row, row.produitId, categorieProduitId, categorieId, "quantite")}
                        onChange={this.handleChange(row.produitId, categorieProduitId, categorieId)} />
                </TableCell>
                <TableCell className="devisContentCategoriesUnite">
                    <FormControl className={`${this.props.classes.formControl} devisContentListeUnite`}>
                        <InputLabel htmlFor="devisContentListeUnite">Unité</InputLabel>
                        <Select
                            value={this.getValue(row, row.produitId, categorieProduitId, categorieId, "uniteId")}
                            onChange={this.handleChangeCustom(row.produitId, categorieProduitId, categorieId)}
                            inputProps={{
                                name: 'uniteId',
                                id: 'devisContentListeUnite'
                            }}>
                            <MenuItem value="">
                                <em>aucune</em>
                            </MenuItem>
                            {uniteList}
                        </Select>
                    </FormControl>
                </TableCell>
                <TableCell className="devisContentCategoriesPrix">
                    <DecimalField
                        id="prix"
                        label="Prix"
                        value={this.getValue(row, row.produitId, categorieProduitId, categorieId, "prix")}
                        onChange={this.handleChange(row.produitId, categorieProduitId, categorieId)} />
                </TableCell>
            </TableRow>
        );
    }

    renderInnerTable(contenu, categorieProduitId, categorieId) {
        var retour = [];
        contenu.forEach(row => {
            retour.push(row.custom === true ? this.showCustomRow(row, categorieProduitId, categorieId) : this.showFixRow(row, categorieProduitId, categorieId)
            );
        });
        return retour;
    }

    handleAddProduct = event => {
        var product = Object.assign({}, devisNewProductBo);
        product.categorieProduitId = this.props.categorieProduitId;
        var id = (parseInt(this.state.customLines) + 1);
        product.contenu[id - 1] =
            {
                "produitLibelle": "",
                "uniteId": "",
                "prix": "",
                "produitId": id * -1,
                "custom": true
            };
        this.props.datas.productsAdded[this.props.categorieProduitId] = product;
        this.setState({ customLines: [id] });
    }

    render() {
        var products = [...this.props.products];
        if (this.props.datas.productsAdded[this.props.categorieProduitId] != null) {
            products.push(...this.props.datas.productsAdded[this.props.categorieProduitId].contenu);
        }
        const { classes } = this.props;
        return (<div>
            <Table className={classes.table}>
                <TableBody>
                    {this.renderInnerTable(products, this.props.categorieProduitId, this.props.categorie)}
                </TableBody>
            </Table>
            <IconButton
                aria-haspopup="true"
                onClick={this.handleAddProduct}
                className="devisAddProduct"
                color="primary"
                title="Ajouter un produit">
                <AddCircle />
            </IconButton >
        </div>);
    }
}

DevisContentTab.propTypes = {
    datas: PropTypes.object.isRequired,
    categorie: PropTypes.number.isRequired,
    categorieProduitId: PropTypes.number.isRequired,
    products: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DevisContentTab);


// WEBPACK FOOTER //
// ./src/components/content/devis/content/DevisContentTab.js